import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import moment from 'moment';
import Constants from "../../Constants";

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data: {
        applicantQualificationIndex: 0
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData();
    },
    methods: {
        switchTab(index){
            this.applicantQualificationIndex = index
        }
        
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        applicantQualificationData() {
            return _.get(this, 'contentData.applicantQualification', []) || [];
        }
    }, // end of computed
}).$mount('#app');